const configMap = new Map<
  string,
  { borderColourClass: string; text: string; textColourClass: string }
>();

configMap.set('in-stock', {
  borderColourClass: 'border-forest',
  text: 'In stock',
  textColourClass: 'text-forest'
});
configMap.set('reseller', {
  borderColourClass: 'border-reseller-blue',
  text: 'Marketplace',
  textColourClass: 'text-reseller-blue'
});
configMap.set('tbc', {
  borderColourClass: 'border-purple-hola',
  text: 'Upcoming',
  textColourClass: 'text-purple-hola'
});
configMap.set('upcoming', {
  borderColourClass: 'border-purple-hola',
  text: 'Upcoming',
  textColourClass: 'text-purple-hola'
});
configMap.set('coming-soon', {
  borderColourClass: 'border-purple-hola',
  text: 'Upcoming',
  textColourClass: 'text-purple-hola'
});
configMap.set('sold-out', {
  borderColourClass: 'border-red-alert',
  text: 'Sold out',
  textColourClass: 'text-red-alert'
});

function normaliseStatus(status: string) {
  return status.toLowerCase().split('_').join('-');
}

export function getStockStatusConfig(status: string) {
  return configMap.get(normaliseStatus(status));
}
